// extracted by mini-css-extract-plugin
export default {"jumpWiggle":"JumpWiggle-module__jumpWiggle--rDQC4","copilotRun":"JumpWiggle-module__copilotRun--Q4K4i"};